<template>
  <div class="w-full xl:w-full flex flex-col space-y-11">
<!--    <div class="relative">-->
<!--      <FormInput-->
<!--        v-model.trim="person"-->
<!--        :placeholder="placeholders.person[inputState.person]"-->
<!--        :invalid="$v.person.$error"-->
<!--        @blur="inputBlurHandler('person')"-->
<!--        @focus="inputFocusHandler('person')"-->
<!--      >-->
<!--        <template #label>-->
<!--          <div>Введи ФИО*</div>-->
<!--        </template>-->
<!--      </FormInput>-->
<!--      <div v-if="$v.person.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">-->
<!--        Введи ФИО, разделяя пробелами фамилию, имя и отчество-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex space-x-4 xl:space-x-0 xl:flex-col">
      <div class="relative w-1/3 xl:w-full">
        <FormInput
          v-model.trim="lastName"
          :placeholder="placeholders.lastName[inputState.lastName]"
          :invalid="$v.lastName.$error"
          @blur="inputBlurHandler('lastName')"
          @focus="inputFocusHandler('lastName')"
        >
          <template #label>
            <div>{{ $t('landing.type-last-name') }}*</div>
          </template>
        </FormInput>
        <div v-if="$v.lastName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
          {{ $t('landing.error:type-last-name') }}
        </div>
      </div>
      <div class="relative w-1/3 xl:w-full xl:mt-9">
        <FormInput
          v-model.trim="firstName"
          :placeholder="placeholders.firstName[inputState.firstName]"
          :invalid="$v.firstName.$error"
          @blur="inputBlurHandler('firstName')"
          @focus="inputFocusHandler('firstName')"
        >
          <template #label>
            <div>{{ $t('landing.type-first-name') }}*</div>
          </template>
        </FormInput>
        <div v-if="$v.firstName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
          {{ $t('landing.error:type-first-name') }}
        </div>
      </div>
      <div class="relative w-1/3 xl:w-full xl:mt-9">
        <FormInput
          v-model.trim="patronymicName"
          :placeholder="placeholders.patronymicName[inputState.patronymicName]"
          :invalid="$v.patronymicName.$error"
          @blur="inputBlurHandler('patronymicName')"
          @focus="inputFocusHandler('patronymicName')"
        >
          <template #label>
            <div>{{ $t('landing.type-patronymic-name') }}</div>
          </template>
        </FormInput>
        <div v-if="$v.patronymicName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
          {{ $t('landing.error:type-patronymic-name') }}
        </div>
      </div>
    </div>
    <div class="flex sm:flex-col sm:space-y-9 space-x-4 sm:space-x-0">
      <div class="relative w-1/2 sm:w-full">
        <FormSelect
          v-model="nationality"
          :options="nationalityOptions"
          placeholder="Гражданство*"
          :invalid="$v.nationality.$error"
          @search-blur="checkData('nationality')"
        >
          <template #label>
            <div>Гражданство*</div>
          </template>
        </FormSelect>
        <div v-if="$v.nationality.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Выбери гражданство
        </div>
      </div>
      <div class="relative w-1/2 sm:w-full">
        <FormInputDate
          v-model="birthday"
          class="date-picker"
          :invalid="$v.birthday.$error"
          :max-date="maxDate"
        >
          <template #label>
            <div>Дата рождения*</div>
          </template>
        </FormInputDate>
        <div v-if="$v.birthday.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Введи дату рождения
        </div>
      </div>
    </div>
    <div class="flex sm:flex-col sm:space-y-9 space-x-4 sm:space-x-0">
      <div class="relative w-1/2 sm:w-full">
        <FormInput
          v-model="phone"
          :invalid="$v.phone.$error"
          :mask="getPhoneMask"
          placeholder="Номер телефона*"
          @blur="checkData('phone')"
        >
          <template #label>
            <div>Номер телефона*</div>
          </template>
        </FormInput>
        <div v-if="$v.phone.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Введи телефон
        </div>
      </div>
      <div class="relative w-1/2 sm:w-full">
        <FormInput
          v-model="email"
          :invalid="$v.email.$error"
          placeholder="E-mail*"
          @blur="checkData('email')"
        >
          <template #label>
            <div>E-mail*</div>
          </template>
        </FormInput>
        <div v-if="$v.email.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Введи корректный E-mail
        </div>
      </div>
    </div>
    <div class="relative w-full">
      <FormSelect
        v-model="communicationMethod"
        :options="communicationMethodOptions"
        :invalid="$v.communicationMethod.$error"
        placeholder="Предпочитаемый способ связи*"
        @search-blur="checkData('communicationMethod')"
      >
        <template #label>
          <div>Предпочитаемый способ связи*</div>
        </template>
      </FormSelect>
      <div v-if="$v.communicationMethod.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
        Выбери предпочитаемый способ связи
      </div>
    </div>
    <div class="relative w-full">
      <FormInput
        v-show="communicationMethod === 'VK'"
        v-model="profile"
        :invalid="$v.profile.$error"
        placeholder="Введите ссылку на профиль в VK*"
        @blur="checkData('profile')"
      >
        <template #label>
          <div>Профиль VK*</div>
        </template>
      </FormInput>
    </div>
    <div class="flex space-x-2 items-start">
      <FormCheckbox
        v-model="agreement"
        :invalid="shouldAgreement"
        @input="($event) => shouldAgreement = !$event"
      />
      <p
        v-if="$route.query.segment === 'SPORTMASTER_UZ' && $route.query.language === 'ru'"
        class="text-left text-base sm:text-sm"
        :class="{ 'text-danger-50': shouldAgreement }"
        v-html="$t('landing.data-processing-and-agreement-links-uz')"
      ></p>
      <p
        v-else
        class="text-left text-base sm:text-sm"
        :class="{ 'text-danger-50': shouldAgreement }"
        v-html="$t('landing.data-processing-and-agreement-links')"
      ></p>
    </div>
    <div class="flex justify-end">
      <Button :disabled="$v.$invalid || !agreement" @click="debouncedSubmit" class="w-1/2">Далее</Button>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash.debounce';
import { required, email } from 'vuelidate/lib/validators';
import FormInput from '@/components/Form/FormInput.vue';
import FormSelect from '@/components/Form/FormSelect.vue';
import FormInputDate from '@/components/Form/FormInputDate.vue';
import FormCheckbox from '@/components/Form/FormCheckbox.vue';
import Button from '@/components/UI/Button.vue';
import toast from '@/notify';
import sanitize from '@/sanitize';
import phoneMaskMixin from '@/mixins/phoneMaskMixin';

export default {
  name: 'UserInfo',
  components: {
    FormInput,
    FormSelect,
    FormInputDate,
    FormCheckbox,
    Button,
  },
  props: {
    nationalityOptions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [phoneMaskMixin],
  data() {
    return {
      // person: '',
      firstName: '',
      lastName: '',
      patronymicName: '',
      nationality: '',
      birthday: new Date('2000-06-01'),
      phone: '',
      email: '',
      agreement: false,
      shouldAgreement: false,
      profile: '',
      friendName: '',
      friendCity: '',
      communicationMethod: 'Телефон',
      communicationMethodOptions: ['Телефон', 'E-mail', 'Telegram', 'WhatsApp', 'Viber', 'VK'],
      inputState: {
        // person: 'blur',
        firstName: 'blur',
        lastName: 'blur',
        patronymicName: 'blur',
      },
      placeholders: {
        // person: {
        //   focus: 'Иванов Иван Иванович',
        //   blur: 'Введи ФИО*',
        // },
        firstName: {
          focus: this.$t('landing.first-name-exemplicant'),
          blur: `${this.$t('landing.type-first-name')}*`,
        },
        lastName: {
          focus: this.$t('landing.last-name-exemplicant'),
          blur: `${this.$t('landing.type-last-name')}*`,
        },
        patronymicName: {
          focus: this.$t('landing.patronymic-name-exemplicant'),
          blur: `${this.$t('landing.type-patronymic-name')}`,
        },
      },
    };
  },
  validations: {
    // person: {
    //   required,
    //   mustBeRussianStrings: (value) => /^[а-яё\s]{1,}(-)?[а-яё\s]{1,} [а-яё\s]{1,} [а-яё\s]{1,}$/i.test(value),
    //   mustHaveThreeWords: (value) => value.split(' ').length === 3,
    //   symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    // },
    lastName: {
      required,
      mustBeRussian: (value) => {
        if (!value) return true;
        switch (this.$i18n.locale) {
          case 'ru':
            return /^[а-яё-]+$/i.test(value.trim());
          default:
            return true;
        }
      },
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
    firstName: {
      required,
      mustBeRussian: (value) => {
        if (!value) return true;
        switch (this.$i18n.locale) {
          case 'ru':
            return /^[а-яё-]+$/i.test(value.trim());
          default:
            return true;
        }
      },
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
    patronymicName: {
      mustBeRussian: (value) => {
        if (!value) return true;
        switch (this.$i18n.locale) {
          case 'ru':
            return /^[а-яё-]+$/i.test(value.trim());
          default:
            return true;
        }
      },
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
    profile: {
      shouldHaveValueIfCurrent: (value, v) => (v.communicationMethod === 'VK' ? !!value : true),
    },
    nationality: {
      required,
    },
    birthday: {
      required,
      belowMaxDate: (value) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const maxYear = currentYear - 1;
        const maxDate = currentDate.setFullYear(maxYear, 11, 31);
        return new Date(value) <= new Date(maxDate);
      },
    },
    phone: {
      validator(value) {
        const pattern = /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/;

        return pattern.test(value);
      },
    },
    email: {
      required,
      email,
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
    communicationMethod: {
      required,
    },
  },
  mounted() {
    const storageData = JSON.parse(sessionStorage.getItem('userInfo'));
    if (storageData) {
      // this.person = storageData.person;
      this.firstName = storageData.firstName;
      this.lastName = storageData.lastName;
      this.patronymicName = storageData.patronymicName;
      this.nationality = storageData.nationality;
      this.birthday = new Date(storageData.birthday);
      this.phone = storageData.phone;
      this.email = storageData.email;
      this.agreement = storageData.agreement;
      this.communicationMethod = storageData.communicationMethod;
    }
  },
  computed: {
    maxDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const maxYear = currentYear - 1;
      const maxDate = currentDate.setFullYear(maxYear, 11, 31);
      return new Date(maxDate);
    },
  },
  methods: {
    /* eslint-disable */
    debouncedSubmit: debounce(
      function () {
        this.submitUserInfo();
      },
      1000,
    ),
    /* eslint-enable */
    submitUserInfo() {
      this.$v.$touch();
      if (!this.agreement) {
        this.shouldAgreement = true;
      }
      if (!this.$v.$invalid && this.agreement) {
        const formData = {
          // person: sanitize(this.person),
          firstName: sanitize(this.firstName),
          lastName: sanitize(this.lastName),
          patronymicName: sanitize(this.patronymicName),
          nationality: this.nationality,
          birthday: this.birthday,
          phone: this.phone,
          email: this.email,
          agreement: this.agreement,
          communicationMethod: this.communicationMethod,
          profile: this.profile,
          friendName: sanitize(this.friendName),
          friendCity: sanitize(this.friendCity),
        };
        this.$emit('user-info-ready', formData);
      }
    },
    checkData(d) {
      this.$v[d].$touch();
      if (d === 'email') {
        const regexp = /^(?:[^:]+:\/\/)?([^.]+\.)*([^.]+)\.([^.]+)(?:$|\/)/;
        const domain = this.email.match(regexp);
        if (!['ru', 'com'].includes(domain[3])) {
          toast.warning({
            title: 'Возможно, есть ошибка',
            text: 'Проверь правильность E-mail, чтобы мы могли связаться с тобой.',
          });
        }
      }
    },
    inputFocusHandler(d) {
      this.inputState[d] = 'focus';
    },
    inputBlurHandler(d) {
      this.inputState[d] = 'blur';
      this.checkData(d);
    },
  },
};
</script>
